<template>
  <mini-card :value="'$'+$store.getters.totalPayouts()" subtitle="Payouts" :previousValue="'$'+$store.getters.totalPayoutsPrevious()">
    <div slot="header" class="icon-warning">
      <i class="fad fa-money-check-edit-alt text-primary"></i>
    </div>
    <template slot="footer">
      <div class="row small">
        <a class="ml-3" href="#" @click="addPayout()"><i class="fas fa-plus mr-1"/>payout</a>
        <a class="mr-3 ml-auto" href="#" @click="managePayouts()"><i class="far fa-edit mr-1"/>manage</a>
      </div>
    </template>
  </mini-card>
</template>

<script>
import {Payout} from 'src/classes/datamodel.js'
import MiniCard from './MiniCard.vue'
export default {
  name: 'Payouts-MiniCard',
  components: {
    MiniCard
  },
  methods: {
    managePayouts () {
      this.$router.push('/admin/payouts')
    },
    addPayout () {
      this.$store.dispatch('openModal', { name: 'Payout', mode: 'Create', object: new Payout({type: Payout._type.MANUAL.value}) })
    }
  }
}
</script>

<style>

</style>